import { z } from "zod";
import { getSystemDisplayName, getSystemIconPath } from "../lib/systemOfRecord";

// --- Schemas ---

export const WorkspaceIntegrationSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  integrationType: z.string(),
  enabled: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type WorkspaceIntegration = z.infer<typeof WorkspaceIntegrationSchema>;

export const IntegrationsListResponseSchema = z.object({
  integrations: z.array(WorkspaceIntegrationSchema),
});

export const AuditBoardConfigSchema = z.object({
  id: z.string(),
  workspaceIntegrationId: z.string(),
  baseUrl: z.string(),
  defaultWorkspaceId: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type AuditBoardConfig = z.infer<typeof AuditBoardConfigSchema>;

export const AuditBoardDetailResponseSchema = z.object({
  integration: WorkspaceIntegrationSchema,
  config: AuditBoardConfigSchema,
  hasApiKey: z.boolean(),
});

export type AuditBoardDetailResponse = z.infer<
  typeof AuditBoardDetailResponseSchema
>;

// --- Registry ---

export type IntegrationCategory = "program_management" | "support_source";

interface IntegrationTypeEntry {
  system: string;
  displayName: string;
  iconPath: string;
  description: string;
  category: IntegrationCategory;
}

export const INTEGRATION_TYPE_REGISTRY: IntegrationTypeEntry[] = [
  {
    system: "auditboard",
    displayName: getSystemDisplayName("auditboard"),
    iconPath: getSystemIconPath("auditboard"),
    description: "Connect to your Optro instance",
    category: "program_management",
  },
  // {
  //   system: "workiva",
  //   displayName: getSystemDisplayName("workiva"),
  //   iconPath: getSystemIconPath("workiva"),
  //   description: "Connect to your Workiva workspace",
  //   category: "program_management",
  // },
];

export function getIntegrationsByCategory(category: IntegrationCategory) {
  return INTEGRATION_TYPE_REGISTRY.filter(
    (entry) => entry.category === category,
  );
}
